import { onlineProductColorSelloutRepository } from './onlineProductColorSellout.repository';

export const getProductColorSelloutRepository = () => onlineProductColorSelloutRepository;
